import type { FaireProductEntity } from "../../entity_types/product";

export const p_c7238w82uk: FaireProductEntity = {
  token: "p_c7238w82uk",
  type: "product",
  name: "Sour Pineapple Vegan Gummy Bears - Real Fruit - Malibu",
  brandName: "California Gummy Bears",
  imageUrl:
    "https://cdn.faire.com/fastly/eed369990191df6f1eeee74068bf9265729afbd1a3d07487cedda55c383c3464.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e35537d6c12141f899a17e3843fc4c082be22a9feebc1c64ec9e2af6c073b38a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
